// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__16myI","select":"Header_select__18RYE","clinic":"Header_clinic__15V3j"};